export default __webpack_public_path__ + "static/media/moodOne.e267b6e7.png";